import {typeColor, typeKey} from "@/utils/trainingTypes";
import "./training-types-matrix.scss";
const number = (value) => (value == null ? "—" : value.toLocaleString("it-IT"));
export default function TrainingExercisesRecap({
	summary,
	exercises = [],
	typeColors,
	metric = "minutes",
	scope = "completed",
}) {
	if (!summary) return null;
	const minutes = metric === "minutes";
	const ordered = [...exercises].sort(
		(a, b) =>
			Number(a.unclassified) - Number(b.unclassified) ||
			a.type.localeCompare(b.type, "it") ||
			a.name.localeCompare(b.name, "it"),
	);
	return (
		<section
			className="rtm__summary"
			aria-label={`Riepilogo esercizi ${scope === "scheduled" ? "programmati" : "svolti"} nel periodo`}
		>
			<header>
				<h3>
					Riepilogo esercizi {scope === "scheduled" ? "programmati" : "svolti"}
				</h3>
				<p>
					<strong>{number(summary[metric])}</strong>{" "}
					{minutes ? <small className="rtm__minute-unit">min</small> : "sedute"}{" "}
					· <strong>{exercises.length}</strong> esercizi
				</p>
			</header>
			{exercises.length > 0 ? (
				<dl
					className="rtm__summary-list"
					tabIndex={0}
					aria-label="Elenco esercizi del periodo"
				>
					{ordered.map((exercise, index) => (
						<div
							key={exercise.exerciseId || `${exercise.name}-${index}`}
							className={
								index > 0 && typeKey(ordered[index - 1]) !== typeKey(exercise)
									? "rtm__summary-row--group-start"
									: undefined
							}
							title={`${exercise.name}
${exercise.type} · ${exercise.sessions} sedute · ${number(exercise.minutes)} min${exercise.missingDuration ? " (parziali)" : ""} · ${exercise.occurrences} esecuzioni`}
							style={{
								borderLeftColor: typeColor(
									{type: exercise.type, unclassified: exercise.unclassified},
									typeColors,
								),
							}}
						>
							<dt>{exercise.name}</dt>
							<dd
								aria-label={`${number(exercise[metric])} ${minutes ? "minuti" : "sedute"}`}
							>
								<strong>
									{number(exercise[metric])}
									{minutes && exercise.missingDuration > 0 ? " *" : ""}
								</strong>
								{minutes && <small className="rtm__minute-unit">min</small>}
							</dd>
						</div>
					))}
				</dl>
			) : (
				<p className="ram__note">
					{summary.sessions
						? "Nessun esercizio inserito nel periodo."
						: "Nessun allenamento nello stato selezionato."}
				</p>
			)}
			{(summary.sessionsWithoutExercises > 0 ||
				summary.missingDuration > 0 ||
				summary.withoutType > 0) && (
				<p
					className="rtm__summary-warning"
					title={`${summary.sessionsWithoutExercises} sedute senza esercizi · ${summary.missingDuration} esercizi senza durata · ${summary.withoutType} senza tipologia`}
				>
					Dati da completare
				</p>
			)}
		</section>
	);
}
